import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  soundPath: "",
};
export const soundsSlice = createSlice({
  name: "sounds",
  initialState,
  reducers: {
    setSoundType: (state, action) => {
      state.soundPath = action.payload;
    }
  },
});

export const { setSoundType } = soundsSlice.actions;

export default soundsSlice.reducer;
